import React, { useEffect, useState } from 'react';
import { Toast } from './Toast';
import { CreativeContext } from './CreativeContext';
import { AttentionBlueprint } from './AttentionBlueprint';
import { ExecutiveSummary } from './ExecutiveSummary';
import { AttentionHeatmap } from './AttentionHeatmap';
import { ViewingContext } from './ViewingContext';
import { DriverAnalysis } from './DriverAnalysis';
import { SystemDynamics } from './SystemDynamics';
import { OverallAssessment } from './OverallAssessment';
import { TopStrengthsImprovements } from './TopStrengthsImprovements';
import { AttentionTestingCTA } from './AttentionTestingCTA';
import { oohData } from '../utils/oohData';
interface DashboardProps {
  timeRange: string;
}
export const Dashboard: React.FC<DashboardProps> = () => {
  const [showToast, setShowToast] = useState(false);
  useEffect(() => {
    // Reset localStorage for testing
    localStorage.removeItem('hasShownNotification');
    // Small delay to ensure component is mounted
    const timer = setTimeout(() => {
      if (window.innerWidth <= 1024) {
        setShowToast(true);
      }
    }, 1000);
    return () => clearTimeout(timer);
  }, []);
  return <div id="report-root" className="space-y-6 relative" data-id="element-136" data-mp="1vrvivo5leojy">
      <Toast show={showToast} onClose={() => setShowToast(false)} data-id="element-137" data-mp="1gvnra2ruukun" />
      <div id="overview" data-id="element-138" data-mp="1lvihs57px8f6">
        <h1 className="text-2xl font-semibold text-gray-900 mb-2" data-id="element-139" data-mp="1luqwpobqyt35">
          OOH Attention Analysis Report
        </h1>
        <p className="text-gray-500 mb-4" data-id="element-140" data-mp="182sulxggdxgh">
          Brandpulse • {oohData.brandContext.brandName} •{' '}
          {new Date().toLocaleDateString('en-GB', {
          month: 'long',
          year: 'numeric'
        })}
        </p>

        {/* Report metadata, so the document stands on its own when circulated */}
        <dl className="flex flex-wrap gap-x-8 gap-y-2 mb-8 text-xs" data-id="element-141" data-mp="1336d3btldv1v">
          {[['Campaign', oohData.reportMeta.campaign], ['Creative', oohData.reportMeta.creativeVersion], ['Market', oohData.reportMeta.market], ['Prepared by', oohData.reportMeta.preparedBy]].map(([label, value]) => <div key={label} data-id="element-142" data-mp="2r20i48yzv8dm">
              <dt className="font-semibold text-gray-500 uppercase tracking-wider mb-0.5" data-id="element-143" data-mp="2r1qpseqh8p4r">
                {label}
              </dt>
              <dd className="text-gray-700 font-medium" data-id="element-144" data-mp="2h4vvy955fcwt">{value}</dd>
            </div>)}
        </dl>

        <div className="space-y-6" data-id="element-145" data-mp="3ese3jgn2q8z8">
          <CreativeContext data-id="element-146" data-mp="3erbd19tny8ju" />
          <AttentionBlueprint data-id="element-147" data-mp="3eqjo2hukn92j" />
          <ExecutiveSummary data-id="element-148" data-mp="39tt1rcs6bh8o" />
          <ViewingContext data-id="element-149" data-mp="39uuncb6tfm4n" />
        </div>
      </div>
      <div id="heatmap" data-id="element-150" data-mp="34ugdqopkg44i">
        <AttentionHeatmap data-id="element-151" data-mp="34tot28xibqt0" />
      </div>
      <div id="analysis" data-id="element-152" data-mp="34sn4r2rhd7tc">
        <DriverAnalysis data-id="element-153" data-mp="34wawpxha1m5y" />
      </div>
      <div id="dynamics" data-id="element-154" data-mp="30tmons0e0ja1">
        <SystemDynamics data-id="element-155" data-mp="30sbkhr3159ie" />
      </div>
      <div id="assessment" data-id="element-156" data-mp="1tfb8bcy1vrh7">
        <OverallAssessment data-id="element-157" data-mp="1tfjlz71zz0tg" />
      </div>
      <div id="recommendations" data-id="element-158" data-mp="1tgmc3crhwz8b">
        <TopStrengthsImprovements data-id="element-159" data-mp="1pdprjgieat1q" />
      </div>
      <div id="next-step" data-id="element-160" data-mp="1pcwsl1poh7u5">
        <AttentionTestingCTA data-id="element-161" data-mp="1pfsqiq1izwil" />
      </div>
    </div>;
};